import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService } from 'ng-jhipster';
import { ModelImage } from './model-image.model';
import { ModelImageService } from './model-image.service';

@Component({
    selector: 'dcs-model-image-detail',
    templateUrl: './model-image-detail.component.html'
})
export class ModelImageDetailComponent implements OnInit, OnDestroy {

    modelImage: ModelImage;
    private subscription: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private modelImageService: ModelImageService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['modelImage']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
    }

    load (id) {
        this.modelImageService.find(id).subscribe(modelImage => {
            this.modelImage = modelImage;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/model-image/model-image-detail.component.ts